import { FieldValues } from 'react-hook-form';
import Select, { SelectProps } from '../../library/Select';
import {
  useSelectFieldController,
  UseSelectFieldControllerProps,
} from '../../../hooks/form/useSelectFieldController';
import ErrorMessage from '../shared/ErrorMessage';

type SelectInputPropsWithControllerProps<TFieldValues> = Omit<
  SelectProps,
  | 'name'
  | 'value'
  | 'defaultValue'
  | 'disabled'
  | 'onChange'
  | 'onBlur'
  | 'required'
  | 'error'
> &
  UseSelectFieldControllerProps<TFieldValues>;

export interface SelectFieldProps<TFieldValues>
  extends SelectInputPropsWithControllerProps<TFieldValues> {}

export default function SelectField<TFieldValues extends FieldValues>(
  props: SelectFieldProps<TFieldValues>,
) {
  const {
    name,
    onChange,
    onBlur,
    defaultValue,
    rules,
    shouldUnregister,
    disabled,
    helperText,
    ...restSelectFieldProps
  } = props;

  const {
    field,
    required,
    onChangeField,
    onBlurField,
    formState: { errors },
    fieldState: { invalid: error },
  } = useSelectFieldController<TFieldValues>({
    name,
    onChange,
    onBlur,
    defaultValue,
    rules,
    shouldUnregister,
    disabled,
  });

  return (
    <Select
      name={field.name}
      value={field.value}
      inputRef={field.ref}
      disabled={field.disabled}
      onChange={onChangeField}
      onBlur={onBlurField}
      error={error}
      required={required}
      helperText={
        error ? <ErrorMessage name={field.name} errors={errors} /> : helperText
      }
      {...restSelectFieldProps}
    />
  );
}
